module.exports = __webpack_public_path__ + "static/img/birthday_pop.0ea17bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/birthday_pop.png
// module id = wOEh
// module chunks = 1